import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'
import { Culture } from '@/types/culture'
import { Treatment } from '@/types/treatment'

import { PulverizationTreatment } from './confirm-pulverization-activity'

export interface GetPulverizationActivityByIdResponse {
  id: string
  start_date: string
  end_date: string
  description: string | null
  confirmedAt?: string | null
  pulverization_treatment?: PulverizationTreatment
  diagnosis: {
    id: string
    culture: Culture
    treatment: Treatment
  }
}

export async function getPulverizationActivityById(
  activityId: string,
  options?: AxiosRequestConfig,
) {
  const { data } = await companiesApi.get<GetPulverizationActivityByIdResponse>(
    apiRoutes.getPulverizationActivityById(activityId),
    options,
  )

  return data
}
